var map = {
	"./call_a.png": "0Gv1",
	"./call_b.png": "OZNc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OEEE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/call_.*\.png$
// module id = OEEE
// module chunks = 12